export enum ExecutorRoutePaths {
	Wizard = 'wizard',
	AddExecutors = 'voeg-uitvoerders-toe',
	SelectMandates = 'voeg-mandaten-toe',
	AddDuration = 'voeg-looptijd-toe',
	SendRequest = 'aanvraag-versturen',
	Success = 'aanvraag-verstuurd',
	Applications = 'aanvragen'
}
